import React from 'react';
import CloseButton from '../CloseButton';

type TitleProps = {
  title: string
  onClose?: () => void
}

export default function ModalTitle({title, onClose}: TitleProps) {
  return (
    <div className="flex flex-row justify-between pb-4">
      <h3 className="text-2xl font-bold " id="modal-headline">
        {title}
      </h3>
      <CloseButton onClose={onClose}/>
    </div>
  );
}
